<div class="container-upload">
  <button [disabled]="disabled" [ngClass]="{'disabled': disabled}" class="upload-btn"(click)="inputFile.click()">Selecteer of maak een foto</button>
  <input name="file"
         id="inputFile"
         (change)="upload($event)"
         accept="image/*" 
         type="file" #inputFile hidden>
</div>
